import type { BriefSectionType } from '../../../lib/sectionTypes';
import { BooleanConfigFields } from './BooleanConfigFields';
import { DateConfigFields } from './DateConfigFields';
import { FileConfigFields } from './FileConfigFields';
import { OptionsConfigFields } from './OptionsConfigFields';
import { TextConfigFields } from './TextConfigFields';

export interface BriefSectionConfigFieldsProps {
  type: BriefSectionType;
  config: Record<string, unknown>;
  onChange: (patch: Record<string, unknown>) => void;
  disabled: boolean;
}

/**
 * Switches on `type`. Five renderers for seven types — `select` and `checklist`
 * share `OptionsConfigFields` (same persisted shape); `url` has no editable
 * config, so it renders nothing.
 */
export function BriefSectionConfigFields(props: BriefSectionConfigFieldsProps) {
  const shared = { config: props.config, onChange: props.onChange, disabled: props.disabled };

  switch (props.type) {
    case 'text':
      return <TextConfigFields {...shared} />;
    case 'date':
      return <DateConfigFields {...shared} />;
    case 'select':
    case 'checklist':
      return <OptionsConfigFields {...shared} />;
    case 'file':
      return <FileConfigFields {...shared} />;
    case 'boolean':
      return <BooleanConfigFields {...shared} />;
    case 'url':
      return null;
  }
}
